import { Component } from '@angular/core';
import { ModalController, NavController } from 'ionic-angular';
import { NodeAvailabilityProvider } from '../../providers/node-availability/node-availability';
import { NativeAudio } from "@ionic-native/native-audio";

@Component({
  selector: 'fab-menu',
  templateUrl: 'fab-menu.html'
})
export class FabMenuComponent {
  public menuOpened: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private availability: NodeAvailabilityProvider,
    private nativeAudio: NativeAudio
  ) {
  }

  openModal() {
    this.availability.checkForNodeAvailabilityOnPushButton();

    this.nativeAudio.stop('RING_AUDIO_KEY');
    this.nativeAudio.stop('PANIC_AUDIO_KEY');
    this.nativeAudio.stop('SMOKE_AUDIO_KEY');

    this.menuOpened = true;
    let addModal = this.modalCtrl.create('ModalMenuPage', undefined, { cssClass: "modal-fullscreen" });
    addModal.onDidDismiss(data => {
      this.menuOpened = false;
      if(data.go){
        this.navCtrl.setRoot(data.go);
      }
    })
    addModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/fab-menu/fab-menu.ts